import SectionJoin from '../components/landing/SectionJoin';
import SectionBanner from '../components/landing/SectionBanner';
import SectionFamilyCare from '../components/landing/SectionFamilyCare';
import SectionJourney from '../components/landing/SectionJourney';
import SectionTestimoni from '../components/landing/SectionTestimoni';
import SectionWorks from '../components/landing/SectionWorks';
import SectionPackage from '../components/landing/SectionPackage';
import SectionProducts from '../components/landing/SectionProducts';
import SectionGuides from '../components/landing/SectionGuides';
import SectionInfaq from '../components/landing/SectionInfaq';

function NewLandingPage() {
  return (
    <div>
      <SectionBanner />
      <SectionFamilyCare />
      <SectionJourney />
      <SectionWorks />
      <SectionPackage />
      <SectionProducts />
      <SectionGuides />
      <SectionInfaq />
      <SectionTestimoni />
      <SectionJoin />
    </div>
  );
}

export default NewLandingPage;
